<template>
    <form method="POST" :action="formUrl" ref="form">
        <div v-if="!jobs && keyType === 'SIGNATURE'"  id="jobsSignModal" class="modal fade" ref="modal" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="div_ai__center mb-3">
                            <input class="form-control" name="jobs-sign" required type="text" placeholder="Укажите вашу должность">
                            <p class="jobsWarning">Введите должность владельца ЭЦП</p>
                            <sign class="mt-3" @xmlReady="submitForm" :xml="signXml" :key-type="keyType" :button-name="buttonName"></sign>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <input type="hidden" name="_token" :value="csrf">
        <input type="hidden" name="status" :value="status">
        <input type="hidden" name="xml"    ref="xmlInput">
        <button v-if="!jobs && keyType === 'SIGNATURE'" type="button" class="btn btn-success" data-bs-toggle="modal" data-bs-target="#jobsSignModal">Подписать</button>

        <sign v-else @xmlReady="submitForm" :xml="signXml" :key-type="keyType" :button-name="buttonName" :button-class="buttonClass"></sign>
        <slot />

    </form>
</template>

<script>
import Sign from './Sign';

export default {
    name: 'SignForm',
    props: {
        status: {
            type: String,
            default: null,
        },
        signXml: String,
        formUrl: String,
        buttonClass: String,
        keyType: {
            type: String,
            default: 'SIGNATURE',
        },
        buttonName: {
            type: String,
            default: 'Подписать',
        },
        jobs: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        };
    },
    methods: {
        submitForm(xml) {
            window.onbeforeunload = null;
            this.$refs.xmlInput.value = xml;
            this.$refs.form.submit();
        },
    },
    components: {
        Sign,
    },
};
</script>
